import { createApp } from "vue";
import AppWrapper from "./AppWrapper.vue";
import seedrandom from "seedrandom";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import "./css-reset.css";
import "./global.css";
import { visible } from "@fresh8/vue-utils/src/directives/visible";

const App = createApp(AppWrapper);

// Create a random seed to determin if we should collect errors for Sentry
const rng = new seedrandom();
if (Math.abs(rng.int32()) < 1000000) {
  Sentry.init({
    dsn:
      "https://68ebf608eb6f4777b265a5b0d5404b6b@o106904.ingest.sentry.io/5557747",
    environment: process.env.NODE_ENV,
    whitelistUrls: [/https?:\/\/(.)*\.fresh8.co/],
    integrations: [new Integrations.BrowserTracing()]
  });
}

App.config.errorHandler = function(err) {
  Sentry.captureException(err);
  console.error(err);
};

App.directive("visible", visible);

App.mount("#app");
